import React from "react";
import { RoleAndPersonaSectionProps } from "../types/types";
import { Form } from "@components";
import { Box, Grid } from "@material-ui/core";
import { Warning as WarningIcon } from "@material-ui/icons";
import { FORM_LABELS, CAPTIONS, REGIONS } from "../constants/constants";

export const RoleAndPersonaSection: React.FC<RoleAndPersonaSectionProps> = ({
  sectionNumber,
  form,
  onFormValueChange,
  userTypeOptions,
  userProfileOptions,
  roleOptions,
  fetching,
  language = "EN",
  region,
}) => {
  const LABELS = FORM_LABELS[language];

  return (
    <>
      {" "}
      <Form.Title>{`${sectionNumber} - ${LABELS.ROLE_PERSONA_ASSIGNMENT.FORM_TITLE}`}</Form.Title>
      <Form.Text color="warning.main">
        <Box display="flex">
          <WarningIcon />
          <Box pl={1} pt={0.5}>
            {LABELS.ROLE_PERSONA_ASSIGNMENT.FORM_NOTE}
          </Box>
        </Box>
      </Form.Text>
      <Grid container spacing={2} item xs={6}>
        <Form.Dropdown
          label={{
            text: LABELS.ROLE_PERSONA_ASSIGNMENT.USER_TYPE,
            tooltip:
              "Sales - Leads, Opportunities, Quotes (GPN Direct Sales)\n" +
              "\n" +
              "CSP - Accounts, Incidents, Terminals (GP Call Center)\n" +
              "\n" +
              "Sales with CSP - GPN Direct Sales and GP Call Center",
          }}
          name="userType"
          onChange={onFormValueChange}
          options={userTypeOptions}
          size={12}
          value={form.values.userType}
          error={form.errors.userType}
          disabled={fetching}
          required
          loading={fetching}
        />
        <Form.Dropdown
          label={{
            text: "Persona",
            tooltip:
              "Please specify the User type above which will determine the appropriate Persona options.",
          }}
          name="profile"
          onChange={onFormValueChange}
          options={userProfileOptions}
          size={12}
          value={form.values.profile}
          error={form.errors.profile}
          disabled={fetching}
          required={form.values.userType !== "Docusign Access Only"}
          loading={fetching}
        />
        <Form.Dropdown
          label={{
            text: "Role",
            tooltip:
              'Instructions: Select a region in Section 1 and then select User Type in Section 3. The role selection will vary depending what you select in the previously mentioned fields. (See "Role Hierarchy" tab for reference.)',
            caption:
              region === REGIONS.MEXICO
                ? CAPTIONS.ROLE_CAPTION.MEXICO
                : CAPTIONS.ROLE_CAPTION.GLOBAL,
          }}
          name="role"
          onChange={onFormValueChange}
          options={roleOptions}
          size={12}
          value={form.values.role}
          error={form.errors.role}
          disabled={fetching || form.values.userType === "Docusign Access Only"}
          required={form.values.userType !== "Docusign Access Only"}
          loading={fetching}
        ></Form.Dropdown>
      </Grid>
      <Grid container spacing={2} item xs={6}>
        <Form.Textarea
          error={form.errors.purposeHybrid}
          label={{
            text: LABELS.ROLE_PERSONA_ASSIGNMENT.PURPOSE_OF_HYBRID_ACCESS,
            caption:
              form.values.userType === "Sales Profile with CSP Access"
                ? "Vivek Pujeri"
                : undefined,
          }}
          name="purposeHybrid"
          onChange={onFormValueChange}
          placeholder={
            LABELS.ROLE_PERSONA_ASSIGNMENT.PURPOSE_OF_HYBIRD_ACCESS_PLACEHOLDER
          }
          rows={5}
          rowsMax={5}
          size={12}
          value={form.values.purposeHybrid}
          disabled={form.values.userType !== "Sales Profile with CSP Access"}
          required={form.values.userType === "Sales Profile with CSP Access"}
        />
      </Grid>
    </>
  );
};
